import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class GlobalSettingsService {
    constructor(private httpClient: HttpClient
    ) {
    }

    getAccountSettingsByName(): Observable<any> {
        return this.httpClient.get('servlets/central/accounts/');
    }

    getEstimatedAppointmentsAffected(strategyId: number): Observable<any> {
        return this.httpClient.get(`servlets/central/accounts/${strategyId}/estimated/`);
    }

    saveAccountStrategy(strategyId: number): Observable<any>  {
        return this.httpClient.post(`servlets/central/accounts/${strategyId}/`, {});
    }

    saveSatelliteStatusToFrom(statusToSatellite, statusFromSatellite): Observable<any>  {
        const statusToSatelliteToBoolean = typeof statusToSatellite === 'number' ? statusToSatellite !== 0 : statusToSatellite;
        const statusFromSatelliteToBoolean = typeof statusFromSatellite === 'number' ? statusFromSatellite !== 0 : statusFromSatellite;
        const accountSettings = {
            statusToSatellite: statusToSatelliteToBoolean,
            statusFromSatellite: statusFromSatelliteToBoolean
        };

        return this.httpClient.post('servlets/central/accounts/satellitestatustofrom/', JSON.stringify(accountSettings));
    }
}
